import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/specialties',
  	  method: 'get',
        params
  	})
  }

export function show(id) {
    return request({
      url: `/specialties/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/specialties',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/specialties/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/specialties/${id}`,
      method: 'delete',
    })
  }
